export const UNKNOWN_CLIENT_FULL_NAME = 'Неизвестный контакт';
export const MISSING_MANAGER_FULL_NAME = 'Нет менеджера';
export const UNKNOWN_MANAGER_FULL_NAME = 'Неизвестный менеджер';
export const TYPES = {
  CLIENT: 'client',
  MANAGER: 'manager',
};
